import useQueryIssue from './useQueryIssue';
import useMutationStatus from './useMutationStatus';
import useMutationComment from './useMutationComment';
import { Status } from './constants';
import { getStatusHelpers } from './utils';

function useIssue(args: { integrationId: number; issueId: number }) {
  const query = useQueryIssue(args);
  const mutationComment = useMutationComment(args);
  const mutationStatus = useMutationStatus(args);

  return {
    comment: {
      save: ({ body, commentId }: { body?: string; commentId?: number }) =>
        mutationComment.mutateAsync({ body, commentId, isPublic: true }),
      isSaving: mutationComment.isLoading,
    },
    isLoading: query.isLoading,
    isMutatingStatus: mutationStatus.isLoading,
    issue: query.data,
    toggleStatus: (status: number) =>
      mutationStatus.mutateAsync(
        getStatusHelpers(status).isOpen ? Status.resolved : Status.open
      ),
  };
}

export default useIssue;
